import { CvProfile } from "@/models";

export const MyCV: CvProfile = {
  name: "Alain Seng",
  title: { en: "Front-end developer", fr: "Développeur Front-end" },
  info: { email: "seng.alain@gmail.com" },
  aboutMe: {
    title: { en: "About me", fr: "Mon profil" },
    description: {
      en: ["About me here"],
      fr: [""]
    }
  },
  objective: {
    title: { en: "Objective", fr: "Objectif" },
    description: {
      en: ["My objective here"],
      fr: [""]
    }
  },
  social: {
    title: { en: "Social presence", fr: "" },
    content: [
      {
        name: { en: "Medium", fr: "Medium" },
        url: "https://medium.com/@Al_un",
        img: ""
      },
      {
        name: { en: "Stack Overflow", fr: "Stack Overflow" },
        url: "https://stackoverflow.com/users/4906586/al-un",
        img: ""
      },
      {
        name: { en: "LinkedIn", fr: "LinkedIn" },
        url: "https://www.linkedin.com/in/alainseng/",
        img: ""
      }
    ]
  },
  skills: {
    title: { en: "Skills and interests", fr: "Compétences et intérêts" },
    content: [
      {
        name: { en: "Front-end", fr: "" },
        skills: [
          {
            name: { en: "JavaScript", fr: "JavaScript" },
            img: "",
            level: 1,
            interest: 1
          },
          {
            name: { en: "Vue.js", fr: "Vue.js" },
            img: "",
            level: 1,
            interest: 1
          },
          {
            name: { en: "Reactjs", fr: "Reactjs" },
            img: "",
            level: 1,
            interest: 1
          }
        ]
      },
      {
        name: { en: "Back-end", fr: "" },
        skills: [
          {
            name: { en: "Go(lang)", fr: "Go(lang)" },
            img: "",
            level: 1,
            interest: 1
          },
          {
            name: { en: "Java", fr: "Java" },
            img: "",
            level: 1,
            interest: 1
          },
          {
            name: { en: "NodeJS", fr: "NodeJS" },
            img: "",
            level: 1,
            interest: 1
          }
        ]
      },
      {
        name: { en: "DevOps", fr: "" },
        skills: [
          {
            name: { en: "Docker", fr: "Docker" },
            img: "",
            level: 1,
            interest: 1
          },
          {
            name: { en: "Kubernetes", fr: "Kubernetes" },
            img: "",
            level: 1,
            interest: 1
          },
          {
            name: { en: "AWS", fr: "AWS" },
            img: "",
            level: 1,
            interest: 1
          },
          {
            name: { en: "Heroku", fr: "Heroku" },
            img: "",
            level: 1,
            interest: 1
          }
        ]
      },
      {
        name: { en: "Databases", fr: "" },
        skills: [
          {
            name: { en: "PostgreSQL", fr: "PostgreSQL" },
            img: "",
            level: 1,
            interest: 1
          },
          {
            name: { en: "MongoDB", fr: "MongoDB" },
            img: "",
            level: 1,
            interest: 1
          }
        ]
      }
    ]
  },
  educations: {
    title: { en: "Education", fr: "" },
    content: [
      {
        title: { en: "Master in Computer Science", fr: "" },
        company: "Ecole Nationale Supérieure des Mines de Nancy",
        description: {
          en: [
            "Majoring in computing science, I choose IT in Art as minor. Main programming language is Java."
          ],
          fr: [""]
        },
        date: {
          start: { en: "2008", fr: "2008" },
          end: { en: "2012", fr: "2012" }
          // start: { en: "Sep-2008", fr: "Sept-2008" },
          // end: { en: "Feb-2012", fr: "Fev-2012" }
        },
        location: { en: "Nancy, France", fr: "Nancy" },
        skills: { en: ["Java"], fr: ["Java"] },
        roles: { en: [""], fr: [""] }
      },
      {
        title: {
          en: "Mathematics / Physics preparatory school",
          fr: "MPSI / MP*"
        },
        company: "Lycée Saint-Louis",
        description: {
          en: [
            "Two required intensive science-focused years before entering into engineering school. I moved to the path of Computer Science (CamL) along with Mathematics and Physics."
          ],
          fr: [""]
        },
        date: {
          start: { en: "2006", fr: "2006" },
          end: { en: "2008", fr: "2008" }
          // start: { en: "Sep-2006", fr: "Sept-2006" },
          // end: { en: "Jun-2008", fr: "Juin-2008" }
        },
        location: { en: "Paris, France", fr: "Paris" },
        skills: { en: ["CamL"], fr: ["CamL"] },
        roles: { en: [""], fr: [""] }
      }
    ]
  },
  experiences: {
    title: { en: "Experiences", fr: "" },
    content: [
      {
        title: { en: "Front-end Lead", fr: "Lead Front-end" },
        company: "Joyz Inc.",
        description: {
          en: ["Pouet"],
          fr: [""]
        },
        date: {
          start: { en: "2019", fr: "2019" },
          end: { en: "Present", fr: "Présent" }
          // start: { en: "Mar-2015", fr: "Mars-2015" },
          // end: { en: "Present", fr: "Présent" }
        },
        location: { en: "Tokyo, Japan", fr: "Tokyo, Japon" },
        skills: { en: [], fr: [] },
        roles: { en: [], fr: [] }
      },
      {
        title: { en: "Co-founder and CTO", fr: "" },
        company: "LS-ware Limited",
        description: {
          en: [""],
          fr: [""]
        },
        date: {
          start: { en: "2015", fr: "2015" },
          end: { en: "2018", fr: "2018" }
          // start: { en: "Mar-2015", fr: "Mars-2015" },
          // end: { en: "Jul-2018", fr: "Juil-2018" }
        },
        location: { en: "Hong Kong", fr: "Hong Kong" },
        skills: { en: [], fr: [] },
        roles: { en: [], fr: [] }
      },
      {
        title: { en: "SAP Architecture consultant", fr: "" },
        company: "Accenture",
        description: {
          en: [
            " I integrated the SAP technical architecture team. As technical consultants, we mainly operate upstream and during the Go-Lives. My missions were mainly based in Paris area but also brought me to Munich, Germany, and Marseille."
          ],
          fr: [""]
        },
        date: {
          start: { en: "2012", fr: "2012" },
          end: { en: "2015", fr: "2015" }
          // start: { en: "Mar-2012", fr: "Mars-2012" },
          // end: { en: "Jan-2015", fr: "Janv-2015" }
        },
        location: { en: "Paris, France", fr: "Paris" },
        skills: { en: [], fr: [] },
        roles: { en: [], fr: [] }
      },
      {
        title: { en: "Infrastructure / IT support engineer", fr: "" },
        company: "SolData Asia Limited",
        description: {
          en: [
            "SolData is a construction site monitoring company. My main duty was the installation of a full VMware solution."
          ],
          fr: [""]
        },
        date: {
          start: { en: "2010", fr: "2011" },
          end: { en: "2010", fr: "2011" }
          // start: { en: "Jul-2010", fr: "Aug-2011" },
          // end: { en: "Jul-2010", fr: "Aout-2011" },
        },
        location: { en: "Hong Kong", fr: "Hong Kong" },
        skills: {
          en: ["Infrastructure", "VMware", "Excel", "VBA"],
          fr: ["Infrastructure", "VMware", "Excel", "VBA"]
        },
        roles: {
          en: ["Infrastructure (80%)", "IT support (20%)"],
          fr: ["Infrastructure (80%)", "Support IT (20%)"]
        }
      }
    ]
  },
  languages: {
    title: { en: "Languages", fr: "Langues" },
    content: [
      {
        name: { en: "French", fr: "Français" },
        level: { en: "Native", fr: "Natif" },
        img: "languages/fr.png"
      },
      {
        name: { en: "English", fr: "Anglais" },
        level: { en: "Business level", fr: "Professionel" },
        img: "languages/uk.png"
      },
      {
        name: { en: "Japanese", fr: "Japonais" },
        level: { en: "Conversational", fr: "Conversation" },
        img: "languages/jp.png"
      }
    ]
  },
  hobbies: {
    title: {
      en: "Hobbies",
      fr: "Loisirs"
    },
    content: [
      { name: { en: "Cycling", fr: "Vélo" } },
      { name: { en: "Bouldering", fr: "Escalade" } },
      { name: { en: "Drawing", fr: "Dessin" } },
      { name: { en: "Cooking", fr: "Cuisine" } },
      { name: { en: "History", fr: "Histoire" } }
    ]
  }
};
